module.exports = __webpack_public_path__ + "img/icon-hamburger.648647b4.svg";